import Helper from '@ember/component/helper';
import { isNone } from '@ember/utils';

export function emptyConditions([conditions] /*, hash*/) {
  if (isNone(conditions)) {
    conditions = [];
  }
  return conditions.length === 0;
}

export default Helper.helper(emptyConditions);
